import React, { useState, useMemo } from 'react';
import { Card, Col, Collapse, Container, Form, FormLabel, Modal, Row, Table } from 'react-bootstrap';
import Service from '../../../components/Systema/Service';
import config from '../../../config';
import './styles.scss';
import { format } from 'date-fns';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Fragment, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import Loading from '../../../components/Loading';
import DataPagination from '../../../components/Systema/Data/DataPagination';
import Paginator from '../../../components/Systema/Data/Paginator';

const sort = { exercicio: 'DESC' };

const filterArquivoPasta = {
  'emendaParlamentarArquivoPasta.nome': 'ASC',
};

const formatValorBR = (valor) => {
  if (valor === null || valor === undefined || valor === '') return '-';
  const numero = Number(valor);
  if (Number.isNaN(numero)) return valor;
  return numero.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export default function EmendaParlamentarPage() {
  const [visivel, setVisivel] = useState(false);
  const [page, setPage] = useState(1);
  const [dadosModal, setDadosModal] = useState({});

  const [filtroExercicio, setFiltroExercicio] = useState('');
  const [filtroAutor, setFiltroAutor] = useState('');
  const [filtroTipoEmenda, setFiltroTipoEmenda] = useState('');
  const [filtroEntidadeBeneficiada, setFiltroEntidadeBeneficiada] = useState('');

  const [filterTable, setFilterTable] = useState({});
  const [showFiltro, setShowFiltro] = useState(false);
  const [filtroRequest, setFiltroRequest] = useState({});
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');

  const service = useMemo(() => {
    return new Service(`${config.api_path}/public/v1/transparencia/emenda-parlamentar/${id}`);
  }, [id]);

  const serviceArquivo = useMemo(() => {
    return new Service(`${config.api_path}/public/v1/transparencia/emenda-parlamentar/arquivo/${id}/${dadosModal.id}`);
  }, [id, dadosModal.id]);

  const show = (row) => {
    setDadosModal(row);
    setVisivel(true);
  };

  const hide = () => setVisivel(false);

  useEffect(() => {
    setFiltroRequest({});
    setLoading(false);
  }, [id]);

  useEffect(() => {
    if (filtroAutor || filtroTipoEmenda || filtroEntidadeBeneficiada || filtroExercicio) {
      setFilterTable({
        exercicio: filtroExercicio ? { $eq: `int:${filtroExercicio}` } : undefined,
        autoria: filtroAutor ? { $ilike: `${filtroAutor}` } : undefined,
        'emendaParlamentarTipo.nome': filtroTipoEmenda ? { $ilike: `${filtroTipoEmenda}` } : undefined,
        'entidadeBeneficiada.nome': filtroEntidadeBeneficiada ? { $ilike: `${filtroEntidadeBeneficiada}` } : undefined,
      });
    } else {
      setFilterTable({});
    }
  }, [filtroAutor, filtroTipoEmenda, filtroEntidadeBeneficiada, filtroExercicio]);

  const handleBuscar = () => {
    setFiltroRequest(filterTable);
  };

  return !loading ? (
    <Container fluid>
      <Card className='mt-4 mb-2'>
        <Card.Body>
          <div className='d-flex justify-content-between'>
            <div>
              <h3 className='font-weight-light my-0'>Emendas Parlamentares</h3>
            </div>
          </div>
        </Card.Body>
      </Card>

      <Card className='my-2'>
        <Card.Header className='py-2' onClick={() => setShowFiltro(!showFiltro)} style={{ cursor: 'pointer' }}>
          <div className='d-flex justify-content-between'>
            <div>
              <Card.Title className='my-0'>Filtros</Card.Title>
            </div>
            <div>
              <FontAwesomeIcon icon={showFiltro ? faMinus : faPlus} />
            </div>
          </div>
        </Card.Header>
        <Collapse in={showFiltro}>
          <div>
            <Card.Body>
              <Row className='mb-3'>
                <Col>
                  <FormLabel>Exercício</FormLabel>
                  <Form.Control
                    type='number'
                    value={filtroExercicio}
                    onChange={(e) => setFiltroExercicio(e.target.value)}
                    placeholder='Ex: 2024'
                  />
                </Col>
                <Col>
                  <FormLabel>Autor</FormLabel>
                  <Form.Control value={filtroAutor} onChange={(e) => setFiltroAutor(e.target.value)} />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col>
                  <FormLabel>Tipo de emenda</FormLabel>
                  <Form.Control value={filtroTipoEmenda} onChange={(e) => setFiltroTipoEmenda(e.target.value)} />
                </Col>
                <Col>
                  <FormLabel>Entidade beneficiada</FormLabel>
                  <Form.Control value={filtroEntidadeBeneficiada} onChange={(e) => setFiltroEntidadeBeneficiada(e.target.value)} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button variant='outline-primary' onClick={handleBuscar}>
                    Buscar
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </div>
        </Collapse>
      </Card>

      <div>
        <Modal show={visivel} onHide={hide} size='xl'>
          <Modal.Header style={{ backgroundColor: '#074E80', height: '50px' }} closeButton />
          <Modal.Body>
            <Row>
              <Col className='text-center mb-3'>
                <h4 className='font-weight-bold'>CADASTRO DA EMENDA</h4>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <p>
                  <strong>Exercício: </strong>
                  {dadosModal.exercicio || '-'}
                </p>
              </Col>
              <Col md={4}>
                <p>
                  <strong>Autor da Emenda: </strong>
                  {dadosModal.autoria || '-'}
                </p>
              </Col>
              <Col md={3}>
                <p>
                  <strong>Tipo da Emenda: </strong>
                  {(dadosModal.emendaParlamentarTipo && dadosModal.emendaParlamentarTipo.nome) || '-'}
                </p>
              </Col>
              <Col md={3}>
                <p>
                  <strong>Município: </strong>
                  {dadosModal.municipio || '-'}
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <p>
                  <strong>Órgão Concedente: </strong>
                  {dadosModal.orgaoConcedente || '-'}
                </p>
              </Col>
              <Col md={4}>
                <p>
                  <strong>Entidade Beneficiada: </strong>
                  {(dadosModal.funcao && dadosModal.funcao.nome) || '-'}
                </p>
              </Col>
              <Col md={4}>
                <p>
                  <strong>CPF/CNPJ: </strong>
                  {dadosModal.documento || '-'}
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={2}>
                <p>
                  <strong>Valor Previsto: </strong>
                  {formatValorBR(dadosModal.valorPrevisto)}
                </p>
              </Col>
              <Col md={2}>
                <p>
                  <strong>Valor Aprovado: </strong>
                  {formatValorBR(dadosModal.valorRealizado)}
                </p>
              </Col>
              <Col md={8}>
                <p>
                  <strong>Conta para depósito: </strong>
                  {dadosModal.contaParaDeposito || '-'}
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <p>
                  <strong>Código Único Segregado: </strong>
                  {dadosModal.codigoUnicoSegregado || '-'}
                </p>
              </Col>
              <Col md={4}>
                <p>
                  <strong>Número da Proposta: </strong>
                  {dadosModal.numeroProposta || '-'}
                </p>
              </Col>
              <Col md={4}>
                <p>
                  <strong>Número da Emenda: </strong>
                  {dadosModal.numeroEmenda || '-'}
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <p>
                  <strong>Painel de Emenda Governo Federal (Consulta Link): </strong>
                  {dadosModal.painelEmendaGovFederal || '-'}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Painel de Emenda Governo Estadual (Consulta Link): </strong>
                  {dadosModal.painelEmendaGovEstadual || '-'}
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <p>
                  <strong>Data da Solicitação da Emenda: </strong>
                  {dadosModal.dataSolicitacaoEmenda ? format(new Date(dadosModal.dataSolicitacaoEmenda), 'dd/MM/yyyy') : '-'}
                </p>
              </Col>
              <Col md={4}>
                <p>
                  <strong>Data da Aprovação da Emenda: </strong>
                  {dadosModal.dataDaEmenda ? format(new Date(dadosModal.dataDaEmenda), 'dd/MM/yyyy') : '-'}
                </p>
              </Col>
              <Col md={4}>
                <p>
                  <strong>Data da Liberação da Emenda: </strong>
                  {dadosModal.dataLiberacaoEmenda ? format(new Date(dadosModal.dataLiberacaoEmenda), 'dd/MM/yyyy') : '-'}
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={3}>
                <p>
                  <strong>Emenda Data do Início: </strong>
                  {dadosModal.dataInicioEmenda ? format(new Date(dadosModal.dataInicioEmenda), 'dd/MM/yyyy') : '-'}
                </p>
              </Col>
              <Col md={3}>
                <p>
                  <strong>Data do Final: </strong>
                  {dadosModal.dataFinalEmenda ? format(new Date(dadosModal.dataFinalEmenda), 'dd/MM/yyyy') : '-'}
                </p>
              </Col>
              <Col md={3}>
                <p>
                  <strong>Termo Aditivo Data Inicial: </strong>
                  {dadosModal.dataInicioTermoAditivo ? format(new Date(dadosModal.dataInicioTermoAditivo), 'dd/MM/yyyy') : '-'}
                </p>
              </Col>
              <Col md={3}>
                <p>
                  <strong>Data Final: </strong>
                  {dadosModal.dataFinalTermoAditivo ? format(new Date(dadosModal.dataFinalTermoAditivo), 'dd/MM/yyyy') : '-'}
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <p>
                  <strong>Fonte de Recurso: </strong>
                  {dadosModal.fonteRecurso || '-'}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Código da Receita: </strong>
                  {dadosModal.codigoReceita || '-'}
                </p>
              </Col>
            </Row>

            <Row>
              <Col className='text-center my-4'>
                <h4 className='font-weight-bold'>MÓDULO DE RASTREABILIDADE</h4>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <p>
                  <strong>Atos Normativos que Aprovou a Emenda: </strong><br />
                  <span style={{ whiteSpace: 'pre-line' }}>{dadosModal.atosNormativos || '-'}</span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <p>
                  <strong>Detalhamento do Objeto Gasto Aprovado na Emenda: </strong><br />
                  <span style={{ whiteSpace: 'pre-line' }}>{dadosModal.detalhamentoObjeto || '-'}</span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <p>
                  <strong>Detalhamento das Ações – Plano de Trabalho-Cronograma Físico Financeiro-Prazo de Execução-Metas a serem alcançadas: </strong><br />
                  <span style={{ whiteSpace: 'pre-line' }}>{dadosModal.detalhamentoAcoes || '-'}</span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <p>
                  <strong>Estágio do Demonstrativo Orçamentário e Financeiro Tempestivo – Receita- Empenho-Liquidação-Pagamento-Anulação Link Consulta: </strong><br />
                  <span style={{ whiteSpace: 'pre-line' }}>{dadosModal.detalhamentoFinanceiro || '-'}</span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <p>
                  <strong>Estágio da Emenda: </strong><br />
                  <span style={{ whiteSpace: 'pre-line' }}>{dadosModal.estagioEmenda || '-'}</span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <p>
                  <strong>Estágio do Processo Licitatório: </strong><br />
                  <span style={{ whiteSpace: 'pre-line' }}>{dadosModal.estagioProcessoLicitatorio || '-'}</span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <p>
                  <strong>Estágio do Controle Orçamentário e Financeiro: </strong><br />
                  <span style={{ whiteSpace: 'pre-line' }}>{dadosModal.estagioControleOrcamentarioFinanceiro || '-'}</span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <p>
                  <strong>Intercorrências: </strong><br />
                  <span style={{ whiteSpace: 'pre-line' }}>{dadosModal.intercorrencias || '-'}</span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <p>
                  <strong>Prestação de Contas da Execução do Objeto da Emenda: </strong><br />
                  <span style={{ whiteSpace: 'pre-line' }}>{dadosModal.prestacaoDeContas || '-'}</span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <p>
                  <strong>Instrumento Jurídico - Convênio-Contratos-Repasses-Termos Aditivos-Apostilamento-Termo de Fomento-Outros: </strong><br />
                  <span style={{ whiteSpace: 'pre-line' }}>{dadosModal.instrumentoJuridico || '-'}</span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <p>
                  <strong>Informações Complementares-Normatização: </strong><br />
                  <span style={{ whiteSpace: 'pre-line' }}>{dadosModal.informacoesComplementares || '-'}</span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <p>
                  <strong>Anotações Complementares - Resolução Nº 302/2025-: </strong><br />
                  <span style={{ whiteSpace: 'pre-line' }}>{dadosModal.anotacoesComplementares || '-'}</span>
                </p>
              </Col>
            </Row>

            <Row className='mt-3'>
              <Col>
                <DataPagination service={serviceArquivo} sort={filterArquivoPasta}>
                  {({ data }) => (
                    <Table className='table-bordered table-hover table-striped'>
                      <thead>
                        <tr>
                          <th>Arquivo</th>
                          <th>Seção</th>
                          <th>Baixar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((row, index) => {
                          const caminho = row.caminho.split('/').slice(2).join('/');
                          const href = row.link ? row.link : `https://transparencia.systemainformatica.com.br/${caminho}`
                          return (
                            <tr key={index}>
                              <td>{row.nome || row.caminho}</td>
                              <td>{row.emendaParlamentarArquivoPasta && row.emendaParlamentarArquivoPasta.nome}</td>
                              <td align='center' style={{ minWidth: 200 }}>
                                <Button target='_blank' href={href}>
                                  Download
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  )}
                </DataPagination>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        <DataPagination sort={sort} service={service} page={page} limit={14} filter={filtroRequest}>
          {({ data, page, lastPage, loading }) => (
            <Fragment>
              <Table className='table-bordered table-hover table-striped'>
                <thead>
                  <tr>
                    <th className='align-middle'>Mais</th>
                    <th className='align-middle'>Exercício</th>
                    <th className='align-middle'>Autor</th>
                    <th className='align-middle'>Tipo de Emenda</th>
                    <th className='align-middle'>Entidade Beneficiada</th>
                    <th className='align-middle'>Detalhamento do Objeto</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, index) => (
                    <tr key={index}>
                      <td className='text-nowrap' align='center'>
                        <Button variant='outline-primary' onClick={() => show(row)}>
                          Detalhes
                        </Button>
                      </td>
                      <td>{row.exercicio || '-'}</td>
                      <td>{row.autoria || '-'}</td>
                      <td>{(row.emendaParlamentarTipo && row.emendaParlamentarTipo.nome) || '-'}</td>
                      <td>{(row.funcao && row.funcao.nome) || '-'}</td>
                      <td>
                        {row.detalhamentoObjeto && row.detalhamentoObjeto.length > 150
                          ? `${row.detalhamentoObjeto.substring(0, 150)}...`
                          : row.detalhamentoObjeto || '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <Paginator page={page} lastPage={lastPage} setPage={setPage} loading={loading} />
            </Fragment>
          )}
        </DataPagination>
      </div>
    </Container >
  ) : (
    <Loading />
  );
}
